import { ReportDefinition, TargetEntityType } from "./reportMetaData";
import { ComponentHelper } from "../core/util/componentHelper";
import { IsSearchField } from "../core/components/isSearchField";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { Helper } from "../core/util/helper";
import { General } from "../../siteManagement/general";
import { SheetEventType } from "../../siteManagement/sheet";
import { NotificationHelper } from "../core/util/notificationHelper";
import { BaseComponentProps } from "../core/components/baseComponentProps";
import { KeyValuePair } from "../commonInterfaces";
import React from "react";
export default class TemplateSearch extends React.Component<TemplateSearchProps, TemplateSearchState>{
    private factory = ComponentHelper.createFactory();
    private elementRef: IsSearchField;
    private storageId: string = "templateSearch_type_dirty"; 
    constructor(props: TemplateSearchProps) {
        super(props);
        this.state = {
            value: null,
            targetEntityType: props.entity.TargetEntityType
        };        
        this.getValue();
        this.initApp();
    }

    private initApp = () => {
        General.Sheet.Manager.getTopMostSheet().bind(SheetEventType.Custom, (data) => {
            if (data.cmd == "targetEntityChanged") {
                if (Helper.hasValue(this.elementRef) && (typeof this.props.entity.TargetEntityType != "string") && (this.props.entity.TargetEntityType != this.state.targetEntityType)) {
                    this.setState({ targetEntityType: this.props.entity.TargetEntityType, value: null })
                } 
            }
        })
    }

    private getValue = async () => {
        if (Helper.hasValue(this.props.value) && Helper.isNumber(this.props.value)) {
            let result = await HTTPService.get<JsonResultClass>("EmailSender/InitTemplate?id=" + this.props.value);
            if (result.Code == 0) {
                this.setValue(result.Data["Id"], result.Data["DisplayName"], true);
            }
        }
    }

    private setValue = (id: number, name: string, isInit: boolean = false) => {
        this.setState({ value: { Key: id, Value: name } }, () => {
            if (!isInit) {
                this.props.onChange({ model: "entity.EmailTemplateId" }, id);
            }
        });
    }

    private getEmailTemplateUrl = () => {
        const baseUrl = "DynamicSearch/Window/emailTemplate?type={type}&fullObject=true&disabled=type&disableType=true";
        //Da in fileSendTemplate bzw fileSendTemplateV2 der typ durch ein String definiert wird
        //-.- 
        switch (this.state.targetEntityType) {
            case TargetEntityType.Address:
                return baseUrl.replace("{type}", "address");
            case TargetEntityType.Assignment:
                return baseUrl.replace("{type}", "resourceplanning");
            case TargetEntityType.CustomReport:
                return baseUrl.replace("{type}", "customreport");
            case TargetEntityType.Machine:
                return baseUrl.replace("{type}", "machine");
            case TargetEntityType.Material:
                return baseUrl.replace("{type}", "material");
            case TargetEntityType.Project:
                return baseUrl.replace("{type}", "project");
            case TargetEntityType.Resource:
                return baseUrl.replace("{type}", "resource");
            case TargetEntityType.ServiceReport:
                return baseUrl.replace("{type}", "servicereport");
            case TargetEntityType.Ticket:
                return baseUrl.replace("{type}", "ticket");
            case TargetEntityType.WeeklyReport:
                return baseUrl.replace("{type}", "weeklyreport");
        }
    }

    private getDefaultTemplate = async () => {
        if (Helper.hasValue(this.state.targetEntityType) && Helper.isNumber(this.state.targetEntityType)) {
            let result = await HTTPService.get<JsonResultClass>("EmailSender/GetDefaultTemplate?id=" + this.state.targetEntityType);
            if (result.Code == 0) {
                if (Helper.hasValue(result.Data)) {
                    this.setValue(result.Data["Id"], result.Data["DisplayName"]);
                } else {
                    NotificationHelper.showWarningMessage(this.props.context.translations["WebCRM.Email.NoDefaultTemplate"]);
                    this.setValue(null, null);
                }
            }
        }
    }

    componentWillUnmount() {
        this.props.onChange({ model: "entity.EmailTemplateId" }, null);
    }

    render() {
        let props = this.factory.getDefaultSearchFieldProps();
        props.disabled = this.props.disabled;
        props.field.searchWindowUrl = this.getEmailTemplateUrl();
        props.field.searchWindowTitle = "Email template search";
        props.field.readOnlyTextField = true;
        props.field.customButtonEnabled = true;
        props.field.customButtonIcon = "star";
        props.field.customButtonTitle = this.props.context.translations["WebCRM.Email.LoadDefaultTemplate"];
        props.field.customButtonFunction = "getDefaultTemplate";
        props.field.deleteButtonEnabled = true;
        props.onChange = (_, value) => {
            if (!Helper.hasValue(value)) {
                this.setValue(null, null);
            }
        }
        props.value = Helper.hasValue(this.state.value) ? this.state.value.Value : "";
        props.handleIsSearchFieldFullObjectModel = (_, dataItem) => {
            this.setValue(dataItem["id"], dataItem["name"])
        }
        props.handleEval = (expression: string) => {
            switch (expression) {
                case "getDefaultTemplate":
                    return this.getDefaultTemplate();
            }
        }
        return <><IsSearchField {...props} ref={(ref) => { this.elementRef = ref }} /></>;
    }

}

interface TemplateSearchProps extends BaseComponentProps {
    entity: ReportDefinition;
    value: number;
    context: any;
}

interface TemplateSearchState {
    value: KeyValuePair<number, string>;
    targetEntityType: TargetEntityType;
}